module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAABJElEQVR4nO3cPWrDUBBF4ecNGLIGV/lpXXpJwu7cZAXpk2zBZAFu0rrRKiItwI0LQ1T4pFAEwYSnIsU8ovPB9JdBoIHRKCVJCgZsgAYNGmA9NKeKTlOwKgFtdIqCNSk6QeEuNmhEArroEAXrElBHpyhYnYAVcI5OUqAzsBpe9Q/AK7AH3idee+AFuI+cTSVJkiRJkhQIWABPwA54m3jtvnuxGJqzBE7o2glYJuAQnaRgB9c+eZ8uDkfYoBF+vJDXJmAbnaJg2wTMgEfgGBymJEf6nsyuB8Y5cDPxmkcM65IkSZIkSZL+DeCW/oAjei9eSj0Dd0NzPIf6XX8OhQd1ObW7+bzO1fMIG5R3cTef9+GvKfKq4VW/xifppxbYRM6mkiT93RfyRI/p0gtgFQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_icon.png
// module id = v2eb
// module chunks = 9